import { render } from "./EvmTokenDepositManual.vue?vue&type=template&id=ed95ba7c"
import script from "./EvmTokenDepositManual.vue?vue&type=script&lang=js"
export * from "./EvmTokenDepositManual.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__